import { ExpandedImageDialog } from "../chat/ExpandedImageDialog";
import type { ExpandedImagePreview } from "../chat/ExpandedImagePreview";

export function NewThreadExpandedImageDialog(props: {
  readonly preview: ExpandedImagePreview | null;
  readonly onClose: () => void;
}) {
  return props.preview ? (
    <ExpandedImageDialog preview={props.preview} onClose={props.onClose} />
  ) : null;
}
